import MaskRemover from './removeMask';

const validarNumerosIguais = (cpfCnpj: string): boolean => { 
  cpfCnpj = cpfCnpj.replace(/[^\d]+/g, '');  
  return /^(\d)\1*$/.test(cpfCnpj); 
};

const getPrimeiroDigitoCpf = (cpfCnpjForValidation:string) => {
  let contagemD1 = 10;
  let numberSumD1 = 0;
  // Calculando primeiro dígito
  for(let i = 0; i < 9; i++){
    numberSumD1 += Number(cpfCnpjForValidation[i]) * contagemD1;
    contagemD1--;
  }
  const result = numberSumD1 % 11;
  let d1Test;
  if(result < 2){
    d1Test = 0;
  }else{
    d1Test = 11 - result;
  }

  const d1 = Number(cpfCnpjForValidation[9]);

  if(d1Test === d1){
    return true;
  }else{
    return false;
  }
};

const getSegundoDigitoCpf = (cpfCnpjForValidation:string) => {
  let contagemD2 = 11;
  let numberSumD2 = 0;
  for(let i = 0; i < 10; i++){
    numberSumD2 += Number(cpfCnpjForValidation[i]) * contagemD2;
    contagemD2--;
  }
  const resultD2 = numberSumD2 % 11;
  let d2Test;
  if(resultD2 < 2){
    d2Test = 0;
  }else{
    d2Test = 11 - resultD2;
  }

  const d2 = Number(cpfCnpjForValidation[10]);

  if(d2Test === d2){
    return true;
  }else{
    return false;
  }
};

const getPrimeiroDigitoCnpj = (cpfCnpjForValidation:string) => {
  const listCalc = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let numberSumD1 = 0;
  for(let i = 0; i < 12; i++){
    numberSumD1 += Number(cpfCnpjForValidation[i]) * listCalc[i];
  }

  const result = numberSumD1 % 11;
  let d1Test;
  if(result < 2){
    d1Test = 0;
  }else{
    d1Test = 11 - result;
  }

  const d1 = Number(cpfCnpjForValidation[12]);

  if(d1Test === d1){
    return true;
  }else{
    return false;
  }

};

const getSegundoDigitoCnpj = (cpfCnpjForValidation:string) => {
  const listCalc2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let numberSumD2 = 0;
  for(let i = 0; i < 13; i++){
    numberSumD2 += Number(cpfCnpjForValidation[i]) * listCalc2[i];
  }

  const result2 = numberSumD2 % 11;
  let d2Test;
  if(result2 < 2){
    d2Test = 0;
  }else{
    d2Test = 11 - result2;
  }

  const d2 = Number(cpfCnpjForValidation[13]);

  if(d2Test === d2){
    return true;
  }else{
    return false;
  }
};

const validaCpfCnpj = (cpfCnpj:string) => {
  const cpfCnpjForValidation = (cpfCnpj.includes('-') && cpfCnpj.includes('.') || cpfCnpj.includes('-') && cpfCnpj.includes('.') && cpfCnpj.includes('/')) ? MaskRemover.removeMask(cpfCnpj) : cpfCnpj;
  if(cpfCnpjForValidation.length === 11 && !validarNumerosIguais(cpfCnpjForValidation)){
    if(getPrimeiroDigitoCpf(cpfCnpjForValidation) && getSegundoDigitoCpf(cpfCnpjForValidation)){
      return true;
    }else{
      alert('CPF inválido');
      return false;
    }         
  } else if(cpfCnpjForValidation.length === 14 && !validarNumerosIguais(cpfCnpjForValidation)){
    if(getPrimeiroDigitoCnpj(cpfCnpjForValidation), getSegundoDigitoCnpj(cpfCnpjForValidation)){
      return true;
    }else{
      alert('CNPJ inválido');
      return false;
    }
  
  } else{
    alert('Cpf ou Cnpj inválidos: Número de caracteres diverge do esperado ou números todos iguais!');
    return false;
  }

};

export default validaCpfCnpj;
